import { BigNumber } from "ethers";
import React from "react";

export type AssetsContextValue = {
  balance?: BigNumber;
  honeyBalance?: BigNumber;
  readHoneyBalance: () => void;
  v1sInWallet?: number[];
  readV1sInWallet: () => void;
  v2sInWallet?: number[];
  readV2sInWallet: () => void;
  fancyBearsInWallet?: number[];
  readFancyBearsInWallet: () => void;
  honeyJarsInWallet?: number[];
  readHoneyJarsInWallet: () => void;
  traitsInWallet?: number[];
  fetchTraitsInWallet: () => void;
};

const AssetsContext = React.createContext<AssetsContextValue>({
  readHoneyBalance: () => {},
  readFancyBearsInWallet: () => {},
  readHoneyJarsInWallet: () => {},
  fetchTraitsInWallet: () => {},
  readV1sInWallet: () => {},
  readV2sInWallet: () => {},
});

export default AssetsContext;
